import { useSearchParams } from 'next/navigation';
import { useCallback, useEffect, useRef, useState } from 'react';

import { getCollections } from '@/services/collection';
import type { CollectionData } from '@/types/collection';

export const PAGE_SIZE = 20;

const useCollection = () => {
  const dataRef = useRef([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState<CollectionData[]>([]);
  const [loading, setLoading] = useState(false);

  const searchParam = useSearchParams();
  const name = searchParam.get('name') ?? '';
  const createdAt = searchParam.get('createdAt') ?? '';
  const tradingVolume = searchParam.get('tradingVolume') ?? '';

  const getInputParams = useCallback(
    (page: number) => ({
      offset: page ? (Number(page) - 1) * PAGE_SIZE : 0,
      size: PAGE_SIZE,
      date: createdAt,
      search: name,
      sort: tradingVolume,
    }),
    [createdAt, name, tradingVolume],
  );

  const handleGetListCollection = async (page: number) => {
    setLoading(true);
    const res = await getCollections(getInputParams(page));
    if (page === 1) {
      dataRef.current = [];
      setData([]);
    }
    dataRef.current = dataRef.current.concat(res?.data || []);
    setData(dataRef.current);
    setLoading(false);
  };

  const loadMore = (page: number) => {
    setCurrentPage(page);
    handleGetListCollection(page);
  };

  useEffect(() => {
    handleGetListCollection(1);
  }, [name, createdAt, tradingVolume]);

  return {
    list: data,
    loading,
    setData,
    currentPage,
    loadMore,
  };
};

export default useCollection;
